<template>
    <type-wrapper class="find_orders" regular>
        <type-grid row="13" margin>
            <type-image mode="widthFix" :src="image"></type-image>
        </type-grid>
        <type-grid row="23" margin>
            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-text type="title" size="9">Find Orders</type-text>
            </type-grid>
            <type-grid row="11" margin style="margin-top: 0;">
                <type-input whitebackdrop clearable v-model="email" placeholder="Email Address" style="flex: 1;"></type-input>
            </type-grid>
            <type-grid row="11" margin style="margin-top: 0;">
                <type-button whitebackdrop border @click="generateCode" :disabled="isGeneratingCode" style="min-width: 40px;">
                        {{ isGeneratingCode ? 'Sending...' : 'Get Code' }}
                    </type-button>
                   <!-- Updated slide verify modal -->
                    <div v-if="showSlideVerify" class="slide-verify-overlay" @click.self="showSlideVerify = false">
                        <div class="slide-verify-modal">
                            <div class="slide-verify-header">
                                <h3>Verify you're not a robot</h3>
                                <button @click="showSlideVerify = false" class="close-btn">×</button>
                            </div>
                            <div class="simple-slide-verify">
                                <div class="slide-track">
                                    <div class="slide-fill" :style="{ width: slideProgress + '%' }"></div>
                                    <div 
                                        class="slide-button" 
                                        :style="{ left: Math.max(2, (slideProgress / 100) * (100 - 10)) + '%' }"
                                        @mousedown="startSlide"
                                        @touchstart="startSlide"
                                    >
                                        {{ slideProgress >= 100 ? '✓' : '→' }}
                                    </div>
                                </div>
                                <div class="slide-text">{{ slideText }}</div>
                            </div>
                        </div>
                    </div>
            </type-grid>


            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-input whitebackdrop clearable v-model="verifyCode" placeholder="Verification Code"></type-input>
            </type-grid>
            <type-grid row="11" margin style="margin-top: 0;margin-bottom: 0;">
                <type-input whitebackdrop clearable v-model="order" placeholder="Order Number"></type-input>
            </type-grid>
            <type-grid row="11" margin>
                <type-button whitebackdrop border @click="findOrder">Find</type-button>
            </type-grid>

            <!-- Document Upload Section -->
            <type-grid row="11" margin v-if="orderList.length">
                <input 
                    ref="docFileInput"
                    type="file" 
                    accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.zip,.mp3,.m4a,.mp4"
                    @change="handleDocFileSelect"
                    style="display: none;"
                />
                <type-button whitebackdrop border @click="triggerDocFileSelect">
                    Load Documents
                </type-button>
            </type-grid>

            <!-- Selected File Display -->
            <type-grid row="11" margin v-if="selectedFile">
                <div class="selected-doc-display">
                    <type-text type="content" size="6" align="center">
                        Selected: {{ selectedFile.name }}
                    </type-text>
                </div>
            </type-grid>

            <!-- Submit Document Button -->
            <type-grid row="11" margin v-if="selectedFile && orderList.length">
                <type-button whitebackdrop border @click="submitDocumentToOrder" :disabled="isUploadingDoc">
                    {{ isUploadingDoc ? 'Uploading...' : 'Submit Document to Order' }}
                </type-button>
            </type-grid>
            <type-grid row="11" margin v-if="orderList.length">
                <div id="order-html">
                    <div class="single-order" v-for="(item, index) in orderList" :key="index">
                        <type-text type="content" size="6" align="center">Order {{index + 1}}</type-text>
                        <type-text type="content" size="6" align="center">Order Number: {{item.order_unique_id}}</type-text>
                        <type-text type="content" size="6" align="center">Product Name: {{item.product_name}}</type-text>
                        <type-text type="content" size="6" align="center">Product Description: {{item.product_description}}</type-text>
                        <type-text type="content" size="6" align="center">Quantity: {{item.quantity}}</type-text>
                        <type-text type="content" size="6" align="center">Unit Price: {{item.final_price/100}}</type-text>
                        <type-text type="content" size="6" align="center">Currency: {{item.currency}}</type-text>
                        <type-text type="content" size="6" align="center">Buyer Name: {{item.receiver_name}}</type-text>
                        <type-text type="content" size="6" align="center">Payment Status: {{item.is_payment_complete ? 'Paid' : 'Unpaid'}}</type-text>

                        <!-- E-Transfer Instructions -->
                        <type-grid row="11" margin v-if="hasETransferInstructions">
                            <div class="etransfer-instructions">
                                <type-text type="title" size="6" align="center">E-Transfer Payment Instructions</type-text>
                                <type-text type="content" size="6" align="center">
                                    Please send e-transfer to: joy@owys.fun<br>
                                    Reference: Your Order Number<br>
                                    Payment will be confirmed within 24 hours.
                                </type-text>
                            </div>
                        </type-grid>
                        
                        <!-- Enhanced Digital Delivery Section -->
                        <div class="digital-delivery-section">
                            <type-text type="content" size="6" align="center" style="margin-bottom: 10px;">
                                <strong>Digital Delivery:</strong>
                            </type-text>
                            
                            <!-- Parse and display files -->
                            <div v-if="parseDigitalDelivery(item.notes).length > 0" class="delivery-files">
                                <!-- Audio Player Section -->
                                <div v-if="getAudioFiles(item.notes).length > 0" class="audio-player-section">
                                    <div class="audio-player-container">
                                        <div class="player-header">
                                            <h4>Audio Files</h4>
                                            <div class="player-controls">
                                                <button @click="togglePlayPause" class="play-btn" :class="{ playing: isPlaying }">
                                                    <span v-if="!isPlaying">▶</span>
                                                    <span v-else>⏸</span>
                                                </button>
                                                <button @click="stopAudio" class="stop-btn">⏹</button>
                                            </div>
                                        </div>
                                        
                                        <!-- Current Track Info -->
                                        <div v-if="currentTrack" class="current-track-info">
                                            <div class="track-name">{{ currentTrack.name }}</div>
                                            <div class="track-time">
                                                {{ formatTime(currentTime) }} / {{ formatTime(duration) }}
                                            </div>
                                        </div>
                                        
                                        <!-- Progress Bar -->
                                        <div class="progress-container" @click="seekAudio">
                                            <div class="progress-bar">
                                                <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
                                                <div class="progress-handle" :style="{ left: progressPercentage + '%' }"></div>
                                            </div>
                                        </div>
                                        
                                        <!-- Volume Control -->
                                        <div class="volume-container">
                                            <span class="volume-icon">Volume</span>
                                            <input 
                                                type="range" 
                                                min="0" 
                                                max="100" 
                                                v-model="volume" 
                                                @input="updateVolume"
                                                class="volume-slider"
                                            >
                                        </div>
                                        
                                        <!-- Playlist -->
                                        <div class="playlist">
                                            <div class="playlist-header">Playlist</div>
                                            <div 
                                                v-for="(audioFile, audioIndex) in getAudioFiles(item.notes)" 
                                                :key="audioIndex"
                                                class="playlist-item"
                                                :class="{ active: currentTrack && currentTrack.url === audioFile.url }"
                                                @click="playTrack(audioFile, audioIndex)"
                                            >
                                                <div class="track-number">{{ audioIndex + 1 }}</div>
                                                <div class="track-info">
                                                    <div class="track-title">{{ audioFile.name }}</div>
                                                </div>
                                                <div class="track-status">
                                                    <span v-if="currentTrack && currentTrack.url === audioFile.url && isPlaying">Replay</span>
                                                    <span v-else-if="currentTrack && currentTrack.url === audioFile.url">⏸</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Other Files Section -->
                                <!-- <div v-if="getNonAudioFiles(item.notes).length > 0" class="other-files-section"> -->
                                    <h4>Download Files</h4>
                                    <div class="file-grid">
                                        <div 
                                            v-for="(file, fileIndex) in getAllFiles(item.notes)" 
                                            :key="fileIndex"
                                            class="file-item"
                                        >
                                            <a :href="file.url" target="_blank" rel="noopener noreferrer" class="file-link">
                                                <!-- <div class="file-icon">{{ getFileIcon(file.extension) }}</div> -->
                                                <div class="file-info">
                                                    <div class="file-name">{{ file.name }}</div>
                                                    <!-- <div class="file-type">{{ file.extension.toUpperCase() }}</div> -->
                                                </div>
                                            </a>
                                        </div>

                                    </div>
                                <!-- </div> -->
                            </div>
                            
                            <!-- No files message -->
                            <div v-else class="no-files">
                                <type-text type="content" size="6" align="center">No digital delivery files available</type-text>
                            </div>
                        </div>
                    </div>
                </div>
            </type-grid>
            <type-grid row="11" margin v-if="orderList.length">
                <type-button whitebackdrop v-print="'#order-html'" border>Print Order</type-button>
            </type-grid>
        </type-grid>
        
        <!-- Audio Element - Always present but hidden -->
        <audio 
            ref="audioPlayer" 
            @timeupdate="updateProgress"
            @loadedmetadata="updateDuration"
            @ended="nextTrack"
            @error="handleAudioError"
            @canplay="onCanPlay"
            @loadstart="onLoadStart"
            preload="metadata"
            style="display: none;"
        ></audio>
    </type-wrapper>
</template>

<script>
export default {
    name: 'find_orders',
    data() {
        return {
            email: '',
            order: '',
            orderList: [],
            image: require('../../assets/image/about-img.jpg'),
            pageData: null,
            
            // Audio player state
            isPlaying: false,
            currentTime: 0,
            duration: 0,
            volume: 50,
            currentTrack: null,
            currentTrackIndex: 0,
            audioFiles: [],
            isLoading: false,
            verifyCode: '',
            isGeneratingCode: false,
            showSlideVerify: false,
            slideProgress: 0,
            isSliding: false,
            slideText: 'Slide to verify',
            codeRequestCount: 0,
            maxFreeAttempts: 2,    // Allow 2 free attempts before requiring slide verify
            selectedFile: null,
            isUploadingDoc: false,
            showDocumentUpload: false
        }
    },
    computed: {
        progressPercentage() {
            if (this.duration === 0) return 0;
            return (this.currentTime / this.duration) * 100;
        },
        hasETransferInstructions() {
            return this.orderList.some(order => 
                order.payment_channel === 'etransfer' && !order.is_payment_complete
            );
        }
    },
    async mounted() {
        await this.getData();
        this.initializeAudioPlayer();
        // Handle auto-search from e-transfer order
        // if (this.$route.query.autoSearch === 'true') {
        //     this.email = this.$route.query.email || '';
        //     this.order = this.$route.query.orderId || '';
        //     if (this.email || this.order) {
        //         this.findOrder();
        //     }
        // }
    },
    beforeDestroy() {
        // Clean up audio when component is destroyed
        this.cleanupAudio();
    },
    methods: {
        // Add these methods after existing methods
        triggerDocFileSelect() {
            this.$refs.docFileInput.click();
        },

        handleDocFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                // Validate file size (max 10MB)
                const maxSize = 10 * 1024 * 1024;
                if (file.size > maxSize) {
                    this.showMessage('File size must be less than 10MB');
                    return;
                }
                this.selectedFile = file;
            }
        },

        async submitDocumentToOrder() {
            if (!this.selectedFile || !this.orderList.length) {
                this.showMessage('Please select a file and ensure order is found');
                return;
            }

            const order = this.orderList[0]; // Use first order
            this.isUploadingDoc = true;

            try {
                const formData = new FormData();
                formData.append('order_id', order.order_unique_id);
                formData.append('customer_email', order.customer_email);
                formData.append('document', this.selectedFile);

                const result = await this.$http.order.addDocToOrder(formData);
                
                if (result.status === 'success') {
                    this.showMessage('Document uploaded successfully!');
                    this.selectedFile = null;
                    this.$refs.docFileInput.value = '';
                    // Refresh order data
                    this.findOrder();
                } else {
                    this.showMessage('Upload failed: ' + (result.message || 'Unknown error'));
                }
            } catch (error) {
                console.error('Document upload error:', error);
                this.showMessage('Upload failed: Network error');
            } finally {
                this.isUploadingDoc = false;
            }
        },
        // Initialize audio player
        initializeAudioPlayer() {
            this.$nextTick(() => {
                if (this.$refs.audioPlayer) {
                    this.$refs.audioPlayer.volume = this.volume / 100;
                    console.log('Audio player initialized');
                } else {
                    console.error('Audio player ref not found');
                }
            });
        },

        // Clean up audio resources
        cleanupAudio() {
            if (this.$refs.audioPlayer) {
                this.$refs.audioPlayer.pause();
                this.$refs.audioPlayer.src = '';
                this.$refs.audioPlayer.load();
            }
        },
        // 生成验证码
        generateCode() {
            if (!this.email) {
                this.showMessage('Please enter email address first');
                return;
            }
            if (this.$verify.verifyEmail(this.email) !== true) {
                this.showMessage('Please enter a valid email address');
                return;
            }
            
            this.isGeneratingCode = true;
            
            this.$http.everify.generate_code({ email: this.email }).then(res => {
                this.isGeneratingCode = false;
                if (res.status === 'success') {
                    this.showMessage('Verification code sent to your email');
                } else {
                    this.showMessage('Failed to send verification code: ' + (res.message || 'Unknown error'));
                }
            }).catch(error => {
                this.isGeneratingCode = false;
                console.error('Generate code error:', error);
                this.showMessage('Failed to send verification code: Network error');
            });
        },
        // Audio event handlers
        onLoadStart() {
            this.isLoading = true;
            console.log('Audio loading started');
        },

        onCanPlay() {
            this.isLoading = false;
            console.log('Audio can play');
        },

        // Parse digital delivery notes into structured file data
        parseDigitalDelivery(notes) {
            if (!notes) return [];
            
            // Split by comma and clean up each URL
            const urls = notes.split(',').map(url => url.trim()).filter(url => url.length > 0);
            
            return urls.map(url => {
                // Clean URL (remove quotes, semicolons, etc.)
                const cleanUrl = url.replace(/[",;]+$/, '').replace(/^[",;]+/, '');
                
                // Extract filename and extension
                const fileName = this.extractFileName(cleanUrl);
                const extension = this.getFileExtension(cleanUrl);
                
                return {
                    url: cleanUrl,
                    name: fileName || cleanUrl,
                    extension: extension.toLowerCase(),
                    isAudio: this.isAudioFile(extension)
                };
            });
        },
        
        // Get only audio files
        getAudioFiles(notes) {
            return this.parseDigitalDelivery(notes).filter(file => file.isAudio);
        },
        
        // Get non-audio files
        getNonAudioFiles(notes) {
            return this.parseDigitalDelivery(notes).filter(file => !file.isAudio);
        },


        // Get all files
        getAllFiles(notes) {
            return this.parseDigitalDelivery(notes);
        },
        
        // Check if file is audio
        isAudioFile(extension) {
            const audioExtensions = ['mp3', 'wav', 'm4a', 'aac', 'ogg', 'flac', 'wma'];
            return audioExtensions.includes(extension.toLowerCase());
        },
        
        // Get file extension
        getFileExtension(url) {
            const cleanUrl = url.split('?')[0].split('#')[0];
            const parts = cleanUrl.split('.');
            return parts.length > 1 ? parts[parts.length - 1] : '';
        },
        
        // Get file icon based on extension
        getFileIcon(extension) {
            const iconMap = {
                'pdf': '?',
                'doc': '?', 'docx': '?',
                'xls': '?', 'xlsx': '?',
                'ppt': '?️', 'pptx': '?️',
                'txt': '?',
                'zip': '?️', 'rar': '?️', '7z': '?️',
                'jpg': '?️', 'jpeg': '?️', 'png': '?️', 'gif': '?️',
                'mp4': '?', 'avi': '?', 'mov': '?',
                'js': '?', 'css': '?', 'html': '?', 'php': '?', 'py': '?'
            };
            return iconMap[extension.toLowerCase()] || '?';
        },
        
        // Audio player methods
        playTrack(track, index) {
            if (!this.$refs.audioPlayer) {
                console.error('Audio player not available');
                return;
            }

            console.log('Playing track:', track.name, track.url);
            
            this.currentTrack = track;
            this.currentTrackIndex = index;
            this.isLoading = true;
            
            // Stop current playback
            this.$refs.audioPlayer.pause();
            this.$refs.audioPlayer.currentTime = 0;
            
            // Set new source
            this.$refs.audioPlayer.src = track.url;
            
            // Load and play
            this.$refs.audioPlayer.load();
            
            // Wait for load then play
            const playPromise = this.$refs.audioPlayer.play();
            
            if (playPromise !== undefined) {
                playPromise.then(() => {
                    this.isPlaying = true;
                    this.isLoading = false;
                    console.log('Playback started successfully');
                }).catch(error => {
                    console.error('Playback failed:', error);
                    this.isPlaying = false;
                    this.isLoading = false;
                    this.showMessage('No audio found');
                });
            }
        },
        
        togglePlayPause() {
            if (!this.$refs.audioPlayer) {
                console.error('Audio player not available');
                return;
            }

            if (!this.currentTrack) {
                console.log('No track selected');
                return;
            }
            
            if (this.isPlaying) {
                this.$refs.audioPlayer.pause();
                this.isPlaying = false;
                console.log('Playback paused');
            } else {
                const playPromise = this.$refs.audioPlayer.play();
                if (playPromise !== undefined) {
                    playPromise.then(() => {
                        this.isPlaying = true;
                        console.log('Playback resumed');
					}).catch(error => {
                        console.error('Resume playback failed:', error);
                        this.isPlaying = false;
                        this.showMessage('No audio found');
                    });
                }
            }
        },
        
        stopAudio() {
            if (!this.$refs.audioPlayer) {
                console.error('Audio player not available');
                return;
            }

            this.$refs.audioPlayer.pause();
            this.$refs.audioPlayer.currentTime = 0;
            this.isPlaying = false;
            this.currentTime = 0;
            console.log('Playback stopped');
        },
        
        nextTrack() {
            // Auto play next track when current ends
            if (!this.orderList.length) return;
            
            const currentOrderAudioFiles = this.getAudioFiles(this.orderList[0].notes);
            if (this.currentTrackIndex < currentOrderAudioFiles.length - 1) {
                this.playTrack(currentOrderAudioFiles[this.currentTrackIndex + 1], this.currentTrackIndex + 1);
            } else {
                // End of playlist
                this.isPlaying = false;
                this.currentTime = 0;
                console.log('Playlist ended');
            }
        },
        
        updateProgress() {
            if (this.$refs.audioPlayer && !isNaN(this.$refs.audioPlayer.currentTime)) {
                this.currentTime = this.$refs.audioPlayer.currentTime;
            }
        },
        
        updateDuration() {
            if (this.$refs.audioPlayer && !isNaN(this.$refs.audioPlayer.duration)) {
                this.duration = this.$refs.audioPlayer.duration || 0;
                console.log('Duration updated:', this.duration);
            }
        },
        
        seekAudio(event) {
            if (!this.$refs.audioPlayer || this.duration === 0) return;
            
            const progressContainer = event.currentTarget;
            const clickX = event.offsetX;
            const width = progressContainer.offsetWidth;
            const percentage = clickX / width;
            const newTime = percentage * this.duration;
            
            this.$refs.audioPlayer.currentTime = newTime;
            this.currentTime = newTime;
            console.log('Seeked to:', newTime);
        },
        
        updateVolume() {
            if (this.$refs.audioPlayer) {
                this.$refs.audioPlayer.volume = this.volume / 100;
                console.log('Volume updated:', this.volume);
            }
        },
        
		handleAudioError(error) {
			console.error('Audio error:', error);
			console.error('Audio element error:', this.$refs.audioPlayer && this.$refs.audioPlayer.error);
			
			this.isPlaying = false;
			this.isLoading = false;
			
			let errorMessage = '音频加载失败';
			if (this.$refs.audioPlayer && this.$refs.audioPlayer.error) {
				switch (this.$refs.audioPlayer.error.code) {
					case 1:
						errorMessage = '音频加载被中止';
						break;
					case 2:
						errorMessage = '网络错误，无法加载音频';
						break;
					case 3:
						errorMessage = '音频解码失败';
						break;
					case 4:
						errorMessage = '不支持的音频格式';
						break;
					default:
						errorMessage = '未知音频错误';
				}
			}
			
			//this.showMessage(errorMessage);
		},
        
        formatTime(seconds) {
            if (isNaN(seconds) || seconds === 0) return '0:00';
            
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = Math.floor(seconds % 60);
            return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
        },

        // 从URL中提取文件名
        extractFileName(url) {
            try {
                // 移除查询参数和锚点
                const cleanUrl = url.split('?')[0].split('#')[0];
                
                // 提取文件名
                const pathParts = cleanUrl.split('/');
                const fileName = pathParts[pathParts.length - 1];
                
                // 如果文件名存在且包含扩展名，返回文件名
                if (fileName && fileName.includes('.')) {
                    return decodeURIComponent(fileName);
                }
                
                return null;
            } catch (error) {
                console.error('提取文件名失败:', error);
                return null;
            }
        },

        // Show message helper
        showMessage(message) {
            if (this.$message) {
                this.$message(message);
            } else {
                alert(message);
            }
        },

        // 添加 getData 方法
        async getData() {
            try {
                const hostname = this.$config.HOSTNAME;
                let hostname_send = hostname;
                
                if (hostname && hostname.startsWith('pager')) {
                    hostname_send = '';
                } else {
                    hostname_send = hostname;
                }

                console.log('HOSTNAME:', hostname);
                
                if (hostname) {
                    const page_tag = 'index';
                    const result = await this.$http.phamula.host_detail(hostname_send, page_tag);
                    
                    if (result.status === 'success' && result.data) {
                        this.pageData = result.data;
                        
                        if (this.pageData.name) {
                            document.title = this.pageData.name;
                        }
                        
                        if (this.pageData.obj_photo) {
                            this.image = this.pageData.obj_photo;
                        }
                        
                        this.updateFavicon(this.pageData.obj_photo);
                    }
                }
            } catch (error) {
                console.error('获取页面数据失败:', error);
            }
        },

        updateFavicon(imageUrl) {
            if (!imageUrl) return;
            this.setFaviconDirect(imageUrl);
            this.convertToIco(imageUrl);
        },

        setFaviconDirect(imageUrl) {
            try {
                const existingLinks = document.querySelectorAll("link[rel*='icon']");
                existingLinks.forEach(link => {
                    if (link.parentNode) {
                        link.parentNode.removeChild(link);
                    }
                });

                const link = document.createElement('link');
                link.rel = 'icon';
                link.type = 'image/png';
                link.href = imageUrl + '?t=' + Date.now();
                document.head.appendChild(link);

                const shortcutLink = document.createElement('link');
                shortcutLink.rel = 'shortcut icon';
                shortcutLink.href = imageUrl + '?t=' + Date.now();
                document.head.appendChild(shortcutLink);

            } catch (error) {
                console.error('设置 favicon 失败:', error);
            }
        },

        convertToIco(imageUrl) {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            
            img.onload = () => {
                try {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    canvas.width = 32;
                    canvas.height = 32;
                    
                    ctx.drawImage(img, 0, 0, 32, 32);
                    
                    const dataURL = canvas.toDataURL('image/png');
                    
                    const link = document.createElement('link');
                    link.rel = 'icon';
                    link.type = 'image/png';
                    link.href = dataURL;
                    document.head.appendChild(link);
                    
                } catch (error) {
                    this.setFaviconDirect(imageUrl);
                }
            };
            
            img.onerror = () => {
                // Silent fail
            };
            
            img.src = imageUrl;
        },

        findOrder() {
            if (!this.email && !this.order) {
                this.showMessage('Please enter email address or order number');
                return false;
            }
            if (this.email && (this.$verify.verifyEmail(this.email) !== true)) {
                this.showMessage('Please enter a valid email address');
                return false;
            }
            
            const req = Object.create(null);
            this.orderList = [];
            
            // Reset audio player state when searching for new orders
            this.stopAudio();
            this.currentTrack = null;
            this.currentTrackIndex = 0;
            
            if (this.email) {
                req.customer_email = this.email;
            }
            if (this.order) {
                req.order_unique_id = this.order;
            }
            if (this.verifyCode) {
                req.verify_code = this.verifyCode;
            }
            console.log('Search request:', JSON.parse(JSON.stringify(req)));
            
            this.$http.order.lists(req).then(res => {
                console.log('Search response:', JSON.parse(JSON.stringify(res)));
                if (res.status === 'success') {
                    if (res.data.list.length) {

                        this.orderList = res.data.list;
                        // Show e-transfer instructions if payment is pending
                        const hasETransferOrders = this.orderList.some(order => 
                            order.payment_channel === 'etransfer' && !order.is_payment_complete
                        );
                        
                        if (hasETransferOrders) {
                            this.showMessage('E-Transfer orders found. Please send payment to complete your order.');
                        }
                        
                        // Initialize audio files for the first order
                        if (this.orderList.length > 0) {
                            this.audioFiles = this.getAudioFiles(this.orderList[0].notes);
                            console.log('Audio files found:', this.audioFiles);
                        }
                        
                        // Initialize audio player after DOM update
                        this.$nextTick(() => {
                            this.initializeAudioPlayer();
                        });
                    } else {
                        this.showMessage('No order information available');
                    }
                } else {
                    this.showMessage('Search failed: ' + (res.message || 'Unknown error'));
                }
            }).catch(error => {
                console.error('Search error:', error);
                this.showMessage('Search failed: Network error');
            });
        },
        generateCode() {
        if (!this.email) {
            this.showMessage('Please enter email address first');
            return;
        }
        if (this.$verify.verifyEmail(this.email) !== true) {
            this.showMessage('Please enter a valid email address');
            return;
        }
        
        this.codeRequestCount++;
        
        // Only show slide verify after maxFreeAttempts
        if (this.codeRequestCount > this.maxFreeAttempts) {
            this.showSlideVerify = true;
        } else {
            this.doGenerateCode();
        }
        },
        
        doGenerateCode() {
            this.isGeneratingCode = true;
            
            this.$http.everify.generate_code({ email: this.email }).then(res => {
                this.isGeneratingCode = false;
                if (res.status === 'success') {
                    this.showMessage('Verification code sent to your email');
                } else {
                    this.showMessage('Failed to send verification code: ' + (res.message || 'Unknown error'));
                }
            }).catch(error => {
                this.isGeneratingCode = false;
                console.error('Generate code error:', error);
                this.showMessage('Failed to send verification code: Network error');
            });
        },
        
        startSlide(e) {
        e.preventDefault();
        this.isSliding = true;
        this.slideText = 'Keep sliding...';
        
        // Get the slider track element reference
        const sliderTrack = e.currentTarget.parentElement;
        
        const moveHandler = (moveEvent) => {
            if (!this.isSliding || !sliderTrack) return;
            
            const rect = sliderTrack.getBoundingClientRect();
            const clientX = moveEvent.touches ? moveEvent.touches[0].clientX : moveEvent.clientX;
            const progress = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
            
            this.slideProgress = progress;
            
            if (progress >= 95) {
                this.completeSlide();
                endHandler(); // Clean up immediately
            }
        };
        
        const endHandler = () => {
            if (this.slideProgress < 95) {
                this.resetSlide();
            }
            this.isSliding = false;
            document.removeEventListener('mousemove', moveHandler);
            document.removeEventListener('mouseup', endHandler);
            document.removeEventListener('touchmove', moveHandler);
            document.removeEventListener('touchend', endHandler);
        };
        
        document.addEventListener('mousemove', moveHandler);
        document.addEventListener('mouseup', endHandler);
        document.addEventListener('touchmove', moveHandler);
        document.addEventListener('touchend', endHandler);
    },
    
    completeSlide() {
        this.slideProgress = 100;
        this.slideText = 'Verified!';
        this.isSliding = false;
        setTimeout(() => {
            this.showSlideVerify = false;
            this.doGenerateCode();
            this.resetSlide();
        }, 500);
    },
    
    resetSlide() {
        setTimeout(() => {
            this.slideProgress = 0;
            this.slideText = 'Slide to verify';
        }, 100);
    }
    }
}
</script>

<style scoped lang="less">


.selected-doc-display {
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    margin: 10px 0;
}
.slide-verify-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.slide-verify-modal {
    background: white;
    border-radius: 8px;
    padding: 20px;
    max-width: 400px;
    width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.slide-verify-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    h3 {
        margin: 0;
        color: #333;
    }
    
    .close-btn {
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #999;
        
        &:hover {
            color: #333;
        }
    }
}

.simple-slide-verify {
    .slide-track {
        position: relative;
        width: 100%;
        height: 40px;
        background: #f0f0f0;
        border-radius: 20px;
        margin-bottom: 10px;
        overflow: hidden; // Add this
        
        .slide-fill {
            position: absolute; // Add this
            top: 0;
            left: 0;
            height: 100%;
            background: linear-gradient(90deg, #4CAF50, #45a049);
            border-radius: 20px;
            transition: width 0.1s ease;
        }
        
        .slide-button {
            position: absolute;
            top: 2px;
            left: 2px; // Change from dynamic left
            width: 36px;
            height: 36px;
            background: white;
            border-radius: 50%;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            transform: translateX(0); // Remove the -50% transform
            user-select: none;
            font-weight: bold;
            color: #666;
            transition: left 0.1s ease; // Add smooth transition
            z-index: 1; // Ensure button is above fill
            
            &:hover {
                box-shadow: 0 4px 8px rgba(0,0,0,0.3);
            }
        }
    }
    
    .slide-text {
        text-align: center;
        color: #666;
        font-size: 14px;
    }
}

.request-info {
    margin-top: 5px;
    text-align: center;
}

.find_orders {
    display: flex;
    flex-wrap: wrap;
    
    .single-order {
        h6 {
            padding: 10px 0 5px;
            font-weight: normal;
        }
        
        p {
            color: #979797;
            font-size: 13.5px;
            line-height: 25px;
            padding-bottom: 5px;
        }
    }
    
    // Digital Delivery Section Styles
    .digital-delivery-section {
        margin: 20px 0;
        padding: 15px;
        background-color: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e9ecef;
        
        .delivery-files {
            margin-top: 15px;
        }
        
        .no-files {
            text-align: center;
            color: #6c757d;
            font-style: italic;
            padding: 20px;
        }
    }
    
    // Audio Player Styles
    .audio-player-section {
        margin-bottom: 25px;
        
        .audio-player-container {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border-radius: 12px;
            padding: 20px;
            color: white;
            box-shadow: 0 8px 32px rgba(0,0,0,0.1);
            
            .player-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 15px;
                
                h4 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 600;
                }
                
                .player-controls {
                    display: flex;
                    gap: 10px;
                    
                    button {
                        background: rgba(255,255,255,0.2);
                        border: none;
                        border-radius: 50%;
                        width: 40px;
                        height: 40px;
                        color: white;
                        cursor: pointer;
                        transition: all 0.3s ease;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                        
                        &:hover {
                            background: rgba(255,255,255,0.3);
                            transform: scale(1.1);
                        }
                        
                        &.playing {
                            background: rgba(255,255,255,0.4);
                        }
                        
                        &:disabled {
                            opacity: 0.5;
                            cursor: not-allowed;
                            transform: none;
                        }
                    }
                }
            }
            
            .current-track-info {
                margin-bottom: 15px;
                
                .track-name {
                    font-size: 16px;
                    font-weight: 500;
                    margin-bottom: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                
                .track-time {
                    font-size: 12px;
                    opacity: 0.8;
                }
            }
            
            .progress-container {
                margin-bottom: 15px;
                cursor: pointer;
                
                .progress-bar {
                    height: 6px;
                    background: rgba(255,255,255,0.3);
                    border-radius: 3px;
                    position: relative;
                    overflow: hidden;
                    
                    .progress-fill {
                        height: 100%;
                        background: linear-gradient(90deg, #ff6b6b, #feca57);
                        border-radius: 3px;
                        transition: width 0.1s ease;
                    }
                    
                    .progress-handle {
                        position: absolute;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 14px;
                        height: 14px;
                        background: white;
                        border-radius: 50%;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                        transition: left 0.1s ease;
                    }
                }
                
                &:hover .progress-handle {
                    transform: translate(-50%, -50%) scale(1.2);
                }
            }
            
            .volume-container {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 20px;
                
                .volume-icon {
                    font-size: 16px;
                }
                
                .volume-slider {
                    flex: 1;
                    height: 4px;
                    background: rgba(255,255,255,0.3);
                    border-radius: 2px;
                    outline: none;
                    cursor: pointer;
                    
                    &::-webkit-slider-thumb {
                        appearance: none;
                        width: 16px;
                        height: 16px;
                        background: white;
                        border-radius: 50%;
						cursor: pointer;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    }
                    
                    &::-moz-range-thumb {
                        width: 16px;
                        height: 16px;
                        background: white;
                        border-radius: 50%;
                        cursor: pointer;
                        border: none;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    }
                }
            }
            
            .playlist {
                .playlist-header {
                    font-size: 14px;
                    font-weight: 600;
                    margin-bottom: 10px;
                    opacity: 0.9;
                }
                
                .playlist-item {
                    display: flex;
                    align-items: center;
                    padding: 8px 12px;
                    margin-bottom: 5px;
                    background: rgba(255,255,255,0.1);
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        background: rgba(255,255,255,0.2);
                        transform: translateX(5px);
                    }
                    
                    &.active {
                        background: rgba(255,255,255,0.3);
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                    }
                    
                    .track-number {
                        width: 24px;
                        height: 24px;
                        background: rgba(255,255,255,0.2);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        font-weight: 600;
                        margin-right: 12px;
                    }
                    
                    .track-info {
                        flex: 1;
                        
                        .track-title {
                            font-size: 14px;
                            font-weight: 500;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                    
                    .track-status {
                        font-size: 16px;
                        margin-left: 10px;
                    }
                }
            }
        }
    }
    
    // Other Files Section Styles
    .other-files-section {
        h4 {
            margin: 0 0 15px 0;
            font-size: 16px;
            font-weight: 600;
            color: #495057;
        }
        
        .file-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
            gap: 12px;
            
            .file-item {
                .file-link {
                    display: flex;
                    align-items: center;
                    padding: 12px;
                    background: white;
                    border: 2px solid #e9ecef;
                    border-radius: 8px;
                    text-decoration: none;
                    color: #495057;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        border-color: #007bff;
                        background: #f8f9ff;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 12px rgba(0,123,255,0.15);
                    }
                    
                    .file-icon {
                        font-size: 24px;
                        margin-right: 12px;
                        width: 32px;
                        text-align: center;
                    }
                    
                    .file-info {
                        flex: 1;
                        
                        .file-name {
                            font-size: 14px;
                            font-weight: 500;
                            margin-bottom: 4px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        
                        .file-type {
                            font-size: 12px;
                            color: #6c757d;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
    
    // Loading indicator
    .loading-indicator {
        display: inline-block;
        width: 20px;
        height: 20px;
        border: 3px solid rgba(255,255,255,.3);
        border-radius: 50%;
        border-top-color: #fff;
        animation: spin 1s ease-in-out infinite;
    }
    
    @keyframes spin {
        to { transform: rotate(360deg); }
    }
    
    // Responsive Design
    @media (max-width: 768px) {
        .digital-delivery-section {
            margin: 15px 0;
            padding: 12px;
        }
        
        .audio-player-section {
            .audio-player-container {
                padding: 15px;
                
                .player-header {
                    flex-direction: column;
                    gap: 10px;
                    align-items: flex-start;
                    
                    .player-controls {
                        align-self: center;
                    }
                }
                
                .current-track-info {
                    .track-name {
                        font-size: 14px;
                    }
                }
                
                .playlist-item {
                    padding: 10px;
                    
                    .track-info .track-title {
                        font-size: 13px;
                    }
                    
                    .track-number {
                        width: 20px;
                        height: 20px;
                        font-size: 11px;
                        margin-right: 8px;
                    }
                }
                
                .volume-container {
                    margin-bottom: 15px;
                }
            }
        }
        
        .other-files-section {
            .file-grid {
                grid-template-columns: 1fr;
                gap: 8px;
            }
            
            .file-item .file-link {
                padding: 10px;
                
                .file-icon {
                    font-size: 20px;
                    width: 28px;
                    margin-right: 10px;
                }
                
                .file-info .file-name {
                    font-size: 13px;
                }
            }
        }
    }
    
    // Small mobile screens
    @media (max-width: 480px) {
        .audio-player-section {
            .audio-player-container {
                padding: 12px;
                
                .player-header {
                    h4 {
                        font-size: 16px;
                    }
                    
                    .player-controls button {
                        width: 36px;
                        height: 36px;
                        font-size: 14px;
                    }
                }
                
                .current-track-info {
                    .track-name {
                        font-size: 13px;
                    }
                    
                    .track-time {
                        font-size: 11px;
                    }
                }
                
                .progress-container .progress-bar {
                    height: 8px;
                    
                    .progress-handle {
                        width: 16px;
                        height: 16px;
                    }
                }
                
                .playlist-item {
                    padding: 8px;
                    
                    .track-number {
                        width: 18px;
                        height: 18px;
                        font-size: 10px;
                        margin-right: 6px;
                    }
                    
                    .track-info .track-title {
                        font-size: 12px;
                    }
                }
            }
        }
    }
    
    // Print Styles
    @media print {
        .audio-player-section {
            display: none !important;
        }
        
        .other-files-section {
            .file-grid {
                display: block;
                
                .file-item {
                    margin-bottom: 10px;
                    
                    .file-link {
                        display: block;
                        border: 1px solid #000;
                        padding: 8px;
                        
                        &::after {
                            content: " (" attr(href) ")";
                            font-size: 0.8em;
                            color: #666;
                        }
                    }
                }
            }
        }
        
        .digital-delivery-section {
            border: 1px solid #000;
            
            .no-files {
                display: none;
            }
        }
    }
    
    // Dark mode support (if needed)
    @media (prefers-color-scheme: dark) {
        .digital-delivery-section {
            background-color: #2d3748;
            border-color: #4a5568;
            color: #e2e8f0;
        }
        
        .other-files-section {
            h4 {
                color: #e2e8f0;
            }
            
            .file-grid .file-item .file-link {
                background: #4a5568;
                border-color: #718096;
                color: #e2e8f0;
                
                &:hover {
                    background: #2d3748;
                    border-color: #63b3ed;
                }
            }
        }
    }
}
</style>